export const trackGA = (event: string, properties: any) => {
  if (!(window as any).dataLayer) {
    (window as any).dataLayer = [];
  }

  (window as any).dataLayer.push({ event, ...properties });
};